<template>
    <div class="card mb-0 shadow">
        <div class="card-body">
            <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                    <h1>Observação na Visita Familiar</h1>
                </div>
            </div>
            <div>
                <h3 class="mt-3" v-if="obsVisitaResponsavel.length > 0">
                    Na visita a criança/adolescente demonstra:
                </h3>
                <load mode="table" v-if="loading" />
                <form
                    v-else
                    @submit.prevent="cadastarobsVisitaResponsavel"
                    ref="addItemResp"
                >
                    <div class="row">
                        <form-select
                            v-model="sentimento"
                            :required="true"
                            :itens="$root.arrays.acolhimento_observacao_visita"
                            label="Na visita a criança/adolescente demonstra"
                            grid="6"
                        />
                        <form-input
                            v-model="responsavel"
                            label="com o(a)"
                            placeholder=" Ex. pai, mãe, avó, avô."
                            grid="6"
                            :required="true"
                        />
                    </div>
                    <div
                        class="row col-12 pb-3 px-0 m-0 d-flex justify-content-end"
                    >
                        <button
                            class="btn btn-primary m-0"
                            data-style="zoom-in"
                            type="submit"
                        >
                            Cadastrar
                        </button>
                    </div>
                </form>
                <div class="row">
                    <div class="col-12" v-if="obsVisitaResponsavel.length > 0">
                        <table class="table table-sm border">
                            <tbody>
                                <tr
                                    v-for="observacao in obsVisitaResponsavel"
                                    :key="observacao.id"
                                >
                                    <td scope="col">
                                        {{
                                            verificarValueArray(
                                                observacao.sentimento,
                                                $root.arrays
                                                    .acolhimento_observacao_visita
                                            )
                                        }}
                                    </td>
                                    <td scope="col">
                                        {{ observacao.responsavel }}
                                    </td>

                                    <td scope="col">
                                        <button
                                            title="Excluir"
                                            @click="
                                                excluirObservacao(
                                                    observacao.id,
                                                    'responsavel'
                                                )
                                            "
                                            class="float-right btn px-2 mb-0 btn-danger btn-xs"
                                        >
                                            <i class="mdi mdi-close"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-12" v-else>
                        <h4 class="text-secondary">
                            <i
                                class="mdi mdi-24px mdi-alert-decagram-outline"
                            ></i>
                            Nada salvo aqui.
                        </h4>
                    </div>
                </div>
            </div>
            <div>
                <h3 class="mt-3" v-if="obsVisitaAspecto.length > 0">
                    Aspectos emocionais do visitante na relação com a
                    criança/adolescente:
                </h3>
                <load mode="table" v-if="loadingAspecto" />
                <form
                    v-else
                    @submit.prevent="cadastarobsVisitaAspecto"
                    ref="addItem"
                >
                    <div class="row">
                        <form-input
                            v-model="responsavel_aspecto"
                            label="Aspectos emocionais na relação com a criança/adolescente"
                            placeholder=" Ex. pai, mãe, avó, avô."
                            grid="6"
                            :required="true"
                        />
                        <form-select
                            v-model="acao"
                            :required="true"
                            :itens="
                                $root.arrays
                                    .acolhimento_observacao_visita_aspectos
                            "
                            label="Sentimento"
                            grid="6"
                        />
                    </div>
                    <div
                        class="row col-12 pb-3 px-0 m-0 d-flex justify-content-end"
                    >
                        <button
                            class="btn btn-primary m-0"
                            data-style="zoom-in"
                            type="submit"
                        >
                            Cadastrar
                        </button>
                    </div>
                </form>
                <div class="row">
                    <div class="col-12" v-if="obsVisitaAspecto.length > 0">
                        <table class="table table-sm border">
                            <tbody>
                                <tr
                                    v-for="observacao in obsVisitaAspecto"
                                    :key="observacao.id"
                                >
                                    <td scope="col">
                                        {{ observacao.responsavel }}
                                    </td>
                                    <td scope="col">
                                        {{
                                            verificarValueArray(
                                                observacao.acao,
                                                $root.arrays
                                                    .acolhimento_observacao_visita_aspectos
                                            )
                                        }}
                                    </td>
                                    <td scope="col">
                                        <button
                                            title="Excluir"
                                            @click="
                                                excluirObservacao(
                                                    observacao.id,
                                                    'aspecto'
                                                )
                                            "
                                            class="float-right btn px-2 mb-0 btn-danger btn-xs"
                                        >
                                            <i class="mdi mdi-close"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-12" v-else>
                        <h4 class="text-secondary">
                            <i
                                class="mdi mdi-24px mdi-alert-decagram-outline"
                            ></i>
                            Nada salvo aqui.
                        </h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            responsavel: "",
            responsavel_aspecto: "",
            sentimento: "",
            acao: "",
            loading: false,
            loadingAspecto: false,
            obsVisitaResponsavel: {},
            obsVisitaAspecto: {},
        };
    },
    watch: {
        item() {
            if (this.item.obsVisitaResponsavel != null) {
                this.obsVisitaResponsavel = this.item.obsVisitaResponsavel;
            }
            if (this.item.obsVisitaAspecto != null) {
                this.obsVisitaAspecto = this.item.obsVisitaAspecto;
            }
        },
    },
    mounted() {
        if (this.item.obsVisitaResponsavel != null) {
            this.obsVisitaResponsavel = this.item.obsVisitaResponsavel;
        }
        if (this.item.obsVisitaAspecto != null) {
            this.obsVisitaAspecto = this.item.obsVisitaAspecto;
        }
    },
    methods: {
        submit() {
            this.item.obsVisitaResponsavel = this.obsVisitaResponsavel;
            this.item.obsVisitaAspecto = this.obsVisitaAspecto;
            this.$emit("submit");
        },
        cadastarobsVisitaResponsavel() {
            this.loading = true;
            axios
                .post(`api/dashboard/acolhimento/storeobsvisita`, {
                    responsavel: this.responsavel,
                    sentimento: this.sentimento,
                    acolhimento_id: this.item.id,
                })
                .then((response) => {
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                    this.$emit("reload");
                })
                .finally(() => {
                    this.responsavel = "";
                    this.sentimento = "";
                    this.loading = false;
                });
        },
        cadastarobsVisitaAspecto() {
            this.loadingAspecto = true;
            axios
                .post(`api/dashboard/acolhimento/storeobsvisitaaspecto`, {
                    responsavel: this.responsavel_aspecto,
                    acao: this.acao,
                    acolhimento_id: this.item.id,
                })
                .then((response) => {
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                    this.$emit("reload");
                })
                .finally(() => {
                    this.acao = "";
                    this.responsavel_aspecto = "";
                    this.loadingAspecto = false;
                });
        },
        excluirObservacao(id, tipo) {
            swal.fire({
                text: "Aguarde a ação ser finalizada.",
                icon: "warning",
                showConfirmButton: false,
                timer: 1500,
            });
            axios
                .post(`api/dashboard/acolhimento/obsvisita/excluir`, {
                    id: id,
                    tipo: tipo,
                })
                .then((response) => {
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                    this.$emit("reload");
                });
        },
        verificarValueArray(value, array, valueIsArray = false) {
            if (valueIsArray && value) {
                var a = "";
                for (var i = 0; i < value.length; i++) {
                    const result = array.filter((item) => item.id == value[i]);
                    a += result[0].value + (i < value.length - 1 ? "," : "");
                }

                return a;
            } else {
                const result = array.filter((item) => item.id == value);
                return result[0] ? result[0].value : "";
            }
        },
    },
};
</script>
